import React from "react";
import Header from "../components/site/header.js";
import Footer from "../components/site/footer.js";
import NewMovie from "../components/add/newmovie.js";

export default function Contribute() {
  return (
    <div className = "newMovie">
        <Header/>
        <NewMovie/>
        <Footer/>
    </div>
  );
}